"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Erc20Controller = void 0;
var ethers_1 = require("ethers");
var utils_1 = require("ethers/lib/utils");
var ERC20_1 = require("../../contracts/ERC20");
var Result_1 = __importDefault(require("../../Result"));
var errors_1 = require("./errors");
/**
 * All the ERC20 Token methods (well mostly)
 */
var Erc20Controller = /** @class */ (function () {
    function Erc20Controller(signer, contractId) {
        this._signer = signer;
        this._contract = new ethers_1.Contract(contractId, new utils_1.Interface(ERC20_1.ABI), this._signer);
    }
    /**
     * Approves erc20 token to be spent in the staking contract
     *
     * @param contractId string - Contract ID for token approval
     * @param amount BigNumber - Amount to approve
     * @returns string - tx hash as string
     */
    Erc20Controller.prototype.approveToken = function (contractId, amount) {
        return __awaiter(this, void 0, void 0, function () {
            var transaction, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this._contract.approve(contractId, amount)];
                    case 1:
                        transaction = _a.sent();
                        return [2 /*return*/, Result_1.default.ok(transaction)];
                    case 2:
                        error_1 = _a.sent();
                        return [2 /*return*/, Result_1.default.fail(errors_1.ERROR_APPROVING_ERC20)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Gets the amount of decimals of token.
     * Stores decimals as private variable after first call since this doesn't change
     *
     * @returns number
     */
    Erc20Controller.prototype.getDecimals = function () {
        return __awaiter(this, void 0, void 0, function () {
            var decimals, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        if (typeof this._decimals === 'number') {
                            return [2 /*return*/, Result_1.default.ok(this._decimals)];
                        }
                        return [4 /*yield*/, this._contract.decimals()];
                    case 1:
                        decimals = _a.sent();
                        this._decimals = decimals;
                        return [2 /*return*/, Result_1.default.ok(decimals)];
                    case 2:
                        error_2 = _a.sent();
                        return [2 /*return*/, Result_1.default.fail(errors_1.ERROR_GETTING_DECIMALS)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Gets token total supply
     *
     * @returns BigNumber
     */
    Erc20Controller.prototype.getTotalSupply = function () {
        return __awaiter(this, void 0, void 0, function () {
            var totalSupply, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this._contract.totalSupply()];
                    case 1:
                        totalSupply = _a.sent();
                        return [2 /*return*/, Result_1.default.ok(totalSupply)];
                    case 2:
                        error_3 = _a.sent();
                        return [2 /*return*/, Result_1.default.fail(errors_1.ERROR_GETTING_TOTAL_SUPPLY)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Get account balance
     *
     * @param account string (optional) - account to get balance. Defaults to signer account
     * @returns BigNumber
     */
    Erc20Controller.prototype.getBalanceOf = function (account) {
        return __awaiter(this, void 0, void 0, function () {
            var balanceOf, address, balanceOf, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 6, , 7]);
                        if (!account) return [3 /*break*/, 2];
                        return [4 /*yield*/, this._contract.balanceOf(account)];
                    case 1:
                        balanceOf = _a.sent();
                        return [2 /*return*/, Result_1.default.ok(balanceOf)];
                    case 2:
                        if (!this._signer) return [3 /*break*/, 5];
                        return [4 /*yield*/, this._signer.getAddress()];
                    case 3:
                        address = _a.sent();
                        return [4 /*yield*/, this._contract.balanceOf(address)];
                    case 4:
                        balanceOf = _a.sent();
                        return [2 /*return*/, Result_1.default.ok(balanceOf)];
                    case 5: return [2 /*return*/, Result_1.default.fail(errors_1.BALANCE_OF_NO_ADDRESS)];
                    case 6:
                        error_4 = _a.sent();
                        return [2 /*return*/, Result_1.default.fail(errors_1.ERROR_GETTING_BALANCE_OF)];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Gets spending allowance of owner
     *
     * @param owner Contract owner
     * @param spender Contract spender
     * @returns BigNumber
     */
    Erc20Controller.prototype.getAllowance = function (owner, spender) {
        return __awaiter(this, void 0, void 0, function () {
            var allowance, error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this._contract.allowance(owner, spender)];
                    case 1:
                        allowance = _a.sent();
                        return [2 /*return*/, Result_1.default.ok(allowance)];
                    case 2:
                        error_5 = _a.sent();
                        return [2 /*return*/, Result_1.default.fail(errors_1.ERROR_GETTING_ALLOWANCE)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return Erc20Controller;
}());
exports.Erc20Controller = Erc20Controller;
